export default class Room {
    constructor(name, description, image){
        this.name = name;
        this.description = description;
        this.image = image;

    }
}